<template>
    <v-card flat :class="!isDialog ? 'ml-4 mr-4' : ''">
      <template v-if="!cadastro">
        <v-card-title class="headline primary--text">
            <v-flex xs12 class="text-xs-center">
                Envie de email para seus Clientes
            </v-flex>
        </v-card-title>
        <v-card-text>
          <v-layout justify-space-between align-end class="ml-4 mr-4 mb-2">
            <v-menu offset-x max-width="400" right>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  small
                  color="error"
                >
                  <v-icon>delete</v-icon>
                </v-btn>
              </template>
              <v-card>
                <v-card-text class="justify-center">
                  <h2>DESEJA EXCLUIR AS INFORMAÇÕES DE E-MAIL?</h2>
                </v-card-text>
                <v-card-actions class="justify-space-between">
                  <v-btn
                    small
                  >
                  Não
                </v-btn>
                <v-btn
                    small
                    color="error"
                    @click="deletar_provedor()"
                  >
                  SIM
                </v-btn>
                </v-card-actions>
              </v-card>
            </v-menu>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  small
                  @click="preparar_dados"
                  color="info"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
              </template>
              Editar Provedor
            </v-tooltip>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" small @click="preVisualizar"><v-icon>remove_red_eye</v-icon></v-btn>
              </template>
              Pré-visualizar email
            </v-tooltip>
          </v-layout>
          <v-form lazy-validation v-model="valid" ref="form">
            <v-select
              v-if="posto && posto.is_simultaneo"
              class="ml-4 mr-4"
              v-model="data.to_white_label"
              label="Para clientes "
              required
              outline
              dense
              :items="apps"
              item-value="value"
              item-text="text"
            />

            <v-text-field
              v-if="isDialog"
              class="ml-4 mr-4"
                v-model="cliente.pessoa.nome_completo"
                label="Para"
                required
                outline
                dense
                readonly
            />

            <v-text-field
              class="ml-4 mr-4"
                v-model="data.subject"
                label="Assunto"
                required
                outline
                dense
                clearable
            />
            <!-- <v-textarea
              class="ml-4 mr-4"
                v-model="mensagem"
                label="Mensagem"
                required
                outline
                height="350"
            /> -->
            <editor-de-texto
              class="ma-4"
              :mensagem="mensagem"
              @editarTexto="function (texto) {
              mensagem = texto
            }"/>
          </v-form>
        </v-card-text>
        <v-card-actions class="justify-space-around">
            <v-flex xs6>
              <v-btn
                v-if="isDialog"
                @click="$emit('fechar')"
                block
                flat
              >
                <v-icon class="mr-1">close</v-icon>
                Fechar
              </v-btn>
            </v-flex>
            <v-divider vertical v-if="isDialog"></v-divider>
            <v-flex :xs6="isDialog" :xs2="!isDialog" :class="!isDialog ? 'mb-2' : ''">
              <v-btn
                @click="enviar"
                block
                color="primary"
                :flat="isDialog"
              >
              Enviar
              <v-icon class="ml-1">send</v-icon>
              </v-btn>
            </v-flex>
        </v-card-actions>
      </template>
      <template v-else>
        <v-card-title class="headline primary--text">
            <v-flex xs12 class="text-xs-center">
                Para poder enviar e-mails para seus clientes, adicione as informações necessárias.
            </v-flex>
        </v-card-title>
        <v-card-text class="text-xs-center">
          <h4>Entre em contato com o seu servidor de e-mail e se informe sobre as configurações de SMTP.</h4>
          <v-form lazy-validation v-model="valid" ref="form">
            <v-text-field
              class="ml-4 mr-4"
              v-model="cadastrar_email.email"
              label="Email do posto"
              required
              outline
              dense
              clearable
            />
            <v-text-field
              class="ml-4 mr-4"
                v-model="cadastrar_email.senha"
                label="Senha"
                required
                outline
                dense
                :type="show ? 'text' : 'password'"
                :append-icon="show ? 'visibility' : 'visibility_off'"
                @click:append="show = !show"
                :rules="[v => !!v || 'Insira um código válido']"
            />
            <v-select
              class="ml-4 mr-4"
              v-model="server"
              label="Selecione sevidor de email"
              required
              single-line
              :items="['Gmail', 'Outlook / Hotmail', 'Yahoo', 'Outro']"
              outline
              dense
            />
           <template v-if="server === 'Outro'">
              <v-text-field
                  class="ml-4 mr-4"
                  v-model="cadastrar_email.server"
                  label="Servidor de email"
                  required
                  outline
                  dense
                  clearable
              />

              <v-text-field
                  class="ml-4 mr-4"
                  v-model="cadastrar_email.porta"
                  label="Porta"
                  required
                  outline
                  dense
                  clearable
              />
            </template>
          </v-form>
        </v-card-text>
        <v-card-actions class="justify-space-around">
          <v-btn
            class="mr-4 mb-2"
            color="primary"
            v-if="provedor"
            @click="cadastro = false"
          >
            Voltar
          </v-btn>
          <v-btn class="mr-4 mb-2" color="primary" @click="() => {
            if (!provedor) return cadastrar_provedor()
            else return atualizar_provedor()
          }">
            Confirmar
          </v-btn>
        </v-card-actions>
      </template>
        <v-dialog v-model="preview" width="600px">
            <template>
                <v-card width="600px" min-height="165px">
                <v-toolbar dark color="primary">
                    <v-btn icon dark @click="preview = false">
                    <v-icon>close</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-toolbar-title class="headline">Visualizar E-mail</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-text color="#ffffff" width="530px" class="mx-auto mt-3">
                    <div v-html="texto_formatado"></div>
                </v-card-text>
                </v-card>
            </template>
        </v-dialog>
    </v-card>
</template>
<script>

import { aesKey, iv } from '@/keys.json'
import EditorDeTexto from './EditorDeTexto.vue'
const CryptoJS = require('crypto-js')

export default {
  props: ['cliente', 'isDialog'],
  components: { EditorDeTexto },
  data () {
    return {
      valid: false,
      outro: false,
      mensagem: '',
      cadastrar_email: {
        server: '',
        porta: '',
        email: '',
        senha: ''
      },
      data: { subject: '', message: '', cnpj: '', senha: '', to_white_label: false, id_pessoa: '' },
      preview: false,
      texto_formatado: '',
      server: '',
      provedor: undefined,
      show: false,
      cadastro: true,
      apps: [
        { text: 'Do seu posto na Apetrus', value: false },
        { text: 'Do seu aplicitivo', value: true }
      ]
    }
  },
  computed: {
    posto () {
      return this.$store.getters.posto
    }
  },
  beforeMount () {
    if (this.cliente && this.cliente.pessoa) {
      this.data.id_pessoa = this.cliente.pessoa.id_pessoa
    }
    if (this.posto) {
      this.pegar_provedor()
      this.data.to_white_label = this.posto.is_white_label
    }
  },
  watch: {
    posto (val) {
      if (val) {
        this.pegar_provedor()
        this.data.to_white_label = val.is_white_label
      }
    },
    provedor (val) {
      if (!val) {
        this.cadastro = true
      } else {
        this.cadastro = false
      }
    }
  },
  methods: {
    preparar_dados () {
      if (this.provedor.servidor === 'smtp.gmail.com') {
        this.server = 'Gmail'
      } else if (this.provedor.servidor === 'SMTP.office365.com') {
        this.server = 'Outlook / Hotmail'
      } else if (this.provedor.servidor === 'smtp.mail.yahoo.com') {
        this.server = 'Yahoo'
      } else {
        this.server = 'Outro'
      }
      this.cadastrar_email.email = this.provedor.email
      this.cadastrar_email.sevidor = this.provedor.sevidor
      this.cadastrar_email.porta = this.provedor.porta
      this.cadastro = true
    },
    pegar_provedor () {
      const data = {
        parametros: {
          posto: this.posto.cnpj
        },
        method: 'GET'
      }

      if (this.provedor) data.id = this.provedor.id
      else if (this.posto.provedor_smtp) data.id = this.posto.provedor_smtp

      this.$store.dispatch('provedorSMTP', data).then(json => {
        this.provedor = json
      }).catch(() => {
        this.provedor = undefined
      })
    },
    deletar_provedor () {
      const data = {
        parametros: {
          posto: this.posto.cnpj
        },
        method: 'DELETE'
      }

      if (this.provedor) data.id = this.provedor.id
      else if (this.posto.provedor_smtp) data.id = this.posto.provedor_smtp
      else {
        this.$emit('error', 'Erro ao tentar deletar provedor de e-mail')
        return
      }

      this.$store.dispatch('provedorSMTP', data).then(() => {
        this.provedor = undefined
      }).catch(() => {
        this.provedor = undefined
      })
    },
    cadastrar_provedor () {
      if (this.server !== 'Outro') {
        if (this.server === 'Gmail') {
          this.cadastrar_email.servidor = 'smtp.gmail.com'
        } else if (this.server === 'Outlook / Hotmail') {
          this.cadastrar_email.servidor = 'SMTP.office365.com'
        } else {
          this.cadastrar_email.servidor = 'smtp.mail.yahoo.com'
        }
        this.cadastrar_email.porta = 587
      }

      const ciphertext = CryptoJS.AES.encrypt(
        JSON.stringify({
          senha: this.cadastrar_email.senha
        }),
        CryptoJS.enc.Utf8.parse(aesKey),
        {
          iv: CryptoJS.enc.Utf8.parse(iv),
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
        }
      ).toString()

      const data = {
        method: 'POST',
        body: {
          ...this.cadastrar_email,
          senha: ciphertext,
          posto: this.posto.cnpj
        }
      }

      this.$store.dispatch('provedorSMTP', data).then(json => {
        this.provedor = json
        this.cadastrar_email = { sevidor: '', porta: '', email: '', senha: '' }
        this.$emit('success', 'E-mail atualizado com sucesso.')
      }).catch(() => {
        this.provedor = undefined
        this.$emit('error', 'Erro no cadastro provedor de e-mail')
      })
    },
    atualizar_provedor () {
      if (this.server !== 'Outro') {
        if (this.server === 'Gmail') {
          this.cadastrar_email.servidor = 'smtp.gmail.com'
        } else if (this.server === 'Outlook / Hotmail') {
          this.cadastrar_email.servidor = 'SMTP.office365.com'
        } else {
          this.cadastrar_email.servidor = 'smtp.mail.yahoo.com'
        }
        this.cadastrar_email.porta = 587
      }

      const ciphertext = CryptoJS.AES.encrypt(
        JSON.stringify({
          senha: this.cadastrar_email.senha
        }),
        CryptoJS.enc.Utf8.parse(aesKey),
        {
          iv: CryptoJS.enc.Utf8.parse(iv),
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
        }
      ).toString()

      const data = {
        method: 'PUT',
        id: this.provedor.id,
        body: {
          ...this.cadastrar_email,
          senha: ciphertext,
          posto: this.posto.cnpj
        }
      }

      this.$store.dispatch('provedorSMTP', data).then(json => {
        this.provedor = json
        this.cadastrar_email = { sevidor: '', porta: '', email: '', senha: '' }
        this.$emit('success', 'Provedor atualizado com sucesso.')
      }).catch(() => {
        this.provedor = undefined
        this.$emit('error', 'Erro no atualizar do provedor de e-mail')
      })
    },
    enviar (senha) {
      if (!senha) {
        this.$emit('error', 'Email invalido. Tente novamente.')
        return
      }
      if (this.$refs.form.validate()) {
        if (this.mensagem === '' || this.data.subject === '') {
          this.$emit('error', 'Email invalido. Tente novamente.')
          return
        }

        this.formatarEmail()
        this.data.posto = this.posto.cnpj
        this.data.senha = senha
        this.$store.dispatch('enviarEmail', this.data).then((value) => {
          if (value === 'ok') {
            this.$emit('success', 'E-mail enviado com Sucesso')
            this.limparCampos()
          } else {
            this.$emit('error', 'Email invalido. Tente novamente')
          }
        }).catch(() => {
          this.$emit('error', 'Email invalido. Tente novamente.')
        })
      } else {
        this.$emit('error', 'Email invalido. Tente novamente.')
      }
    },
    formatarEmail () {
      this.data.message = this.mensagem
      this.texto_formatado = `
        <!DOCTYPE html>
        <html>
            <head>
                <style>
                    .price {
                            color: grey;font-size: 22px;
                    }
                    .card a{
                            text-decoration: none;color: #4169E1;
                    }
                    .strong {
                      font-weight: 900;
                    }
                    .ql-syntax {
                      background-color: black;
                      color: white;
                    }
                    .ql-align-center {
                      text-align: center;
                    }
                    .ql-align-right {
                      text-align: right;
                    }
                    .ql-align-justify {
                      text-align: justify;
                    }
                    ql-indent-1 {
                    }
                    ql-indent-2 {
                    }
                    ql-indent-3 {
                    }
                    ql-indent-4 {
                    }
                    ql-indent-5 {
                    }
                    ql-indent-6 {
                    }
                    ql-indent-7 {
                    }
                    ql-indent-8 {
                    }
                    img {
                      max-width: 100%;
                    }
                </style>
            </head>
            <body>
              ${this.data.message}
            </body>
        </html>`
      this.data.message = this.texto_formatado
    },
    preVisualizar () {
      this.formatarEmail()
      this.preview = true
    },
    limparCampos () {
      this.texto_formatado = ''
      this.mensagem = ''
      this.data.message = ''
      this.data.subject = ''
    }
  }
}
</script>
